import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { DateNullable } from "../../../../../pipes/date-pipe";
import { CustomRight } from "../../../../../pipes/custom-right-pipe";
import { SlashToLineBreak } from "../../../../../pipes/slash-line-break.pipe";
import { MatCheckbox } from "@angular/material/checkbox";
@Component({
  selector: "app-list-element",
  templateUrl: "./list-element.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./list-element.component.scss"],
  imports: [MatCheckbox]
})
export class ListElementComponent {
  @Output() selectElement: EventEmitter<any> = new EventEmitter();
  @Output() selectDevice: EventEmitter<any> = new EventEmitter();

  @Input() displayObject: any;
  @Input() properties: any[];

  readonly BOOLEAN_TRUE: string =
    "../../../../../../assets/img/manager/boolean-true.svg";
  readonly BOOLEAN_FALSE: string =
    "../../../../../../assets/img/manager/boolean-false.svg";

  constructor(
    private slashToLineBreak: SlashToLineBreak,
    private dateNullable: DateNullable,
    private customRight: CustomRight
  ) {}

  /**
   *
   * @param property
   * @param value
   * @returns any
   * @description This function formats the property value based on the property name.
   */
  formatProperty(property: string, value: any): any {
    if (property === "rightId") {
      return this.slashToLineBreak.transform(value);
    } else if (property.includes("Date") || property.includes("date")) {
      return this.dateNullable.transform(value);
    } else if (property === "profileContainerTypeId") {
      return this.customRight.transform(value);
    } else return value;
  }

  onSelect(event) {
    event.preventDefault();
    if (!this.displayObject.disabled) {
      this.selectElement.emit(this.displayObject);
    }
  }
}
